<template>
<div class="px-3 md:w-1/3" >
    <form method="POST" @submit="saveNewsletter">
        <div class="flex">
            <div >
                <ValidationProvider name="name" rules="required" :bails="false" v-slot="{ errors}" >
                    <label class="flex">
                        <div class="z-10 flex items-center justify-center w-10 pl-1 text-center pointer-events-none"><i class="text-lg text-gray-400 mdi mdi-email-outline"></i></div>
                        <input type="email" class="px-2 py-2 -ml-10 border-t-2 border-b-2 border-l-2 border-gray-200 rounded-l-lg outline-none md:w-80 md:px-9 focus:border-pink-600" placeholder="email@example.com" v-model="form.email" required>
                    </label>
                    <span class="text-xs font-medium text-red-600">{{ errors[0] }}</span>
                </ValidationProvider>
            </div>
            <div>
                <button :disabled="!isComplete" type="submit" @click="showSuccess = true" v-show="!showSuccess"  class="block w-full px-3 py-2.5 font-semibold text-white transition-colors bg-pink-600 rounded-r-lg hover:bg-indigo-700 focus:bg-indigo-700 hover:shadow-custom">Iscriviti</button>
            </div>
        </div>
        <div class="flex justify-start w-full py-3">
            <ValidationProvider name="privacy" rules="required" :bails="false" v-slot="{ errors}" class="inline-flex items-center">
                <label class="inline-flex">
                    <input class="mt-1.5 md:w-6 md:h-6" type="checkbox" v-model="form.privacy" required>
                    <span class="ml-2 text-xs font-normal md:w-96">Dichiaro di aver ricevuto, letto e compreso <router-link to="/privacy-policy" class="text-pink-600 hover:underline">l'informativa</router-link> ai sensi del Reg. UE 2016/679 (Art. 13) e presto il consenso al trattamento dei miei dati personali.</span>
                </label>
                <span class="text-xs text-red-600">{{ errors[0] }}</span>
            </ValidationProvider>
        </div> 
    </form>  
    <div class="px-2 py-3 text-lg font-semibold text-center text-red-500 bre" v-if="result === 'Email Already Exits!' ">L'ID e-mail esiste già!
    </div>
    <div v-else-if="result !== 'Email Already Exits!' && result != '' ">
        <p class="px-2 py-3 text-lg font-semibold text-center text-green-500 bre">Grazie!</p>
    </div>  
</div>
</template>

<script>
import axios from "axios";
import { ValidationProvider, extend } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';
import { configure } from 'vee-validate';


extend('required', {
    ...required,
    message: 'Questo campo è richiesto'
});

configure({
    classes: {
        valid: 'is-valid',
        invalid: 'is-invalid',
        dirty: ['is-dirty', 'is-dirty'],
    }
});

export default {
    components: {
        ValidationProvider
    },
    data() {
            return {
                showSuccess: false,
                result: '',
                form: {
                    email: '',
                    privacy: ''
                },
            };
        },
        computed: {
            isComplete () {
                return this.form.email && this.form.privacy;
            }
        },
        methods: {
            saveNewsletter(e) {
                e.preventDefault();
                    let currentObj = this;
                    axios.post('/api/store/newsletter', {
                        email: this.form.email,
                    }).then(function (response) {
                    currentObj.result = response.data.message;
                })
                .catch(function (error) {
                    console.log(error);
              });
            },
        }
    }
</script>


<style lang="scss" scoped>
    input:valid {
    border-color: #10b981;
    background-color: #deeee9;
    }
    button[disabled] {
        opacity: 0.35;
    }
    input[type=radio]{
    margin-right: 8px;
    }
    .select select.changed,
    .input.changed {
        border: 2px solid #7ED321;
    }
    .select select.passed,
    .input.passed {
        border: 2px solid #7ED321;
        background: rgb(214, 238, 188);
    }
</style>